export default __webpack_public_path__ + "static/media/image4.6f8bbf5c.jpg";